import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import PATH from "../../urls/path";

interface NewLoginStateInterface {
    newLogin: boolean;
    inputUrl: string;
}

const newLoginSliceState: NewLoginStateInterface = {
    newLogin: false,
    inputUrl: PATH.dashboard
};

export const newLoginSlice = createSlice({
    name: "newLogin",
    initialState: newLoginSliceState,
    reducers: {
        setNewLoginStatus: (state, action: PayloadAction<boolean>) => {
            state.newLogin = action.payload;
        },
        setInputUrl: (state, action: PayloadAction<string>) => {
            state.inputUrl = action.payload;
        }
    }
});

export const { setNewLoginStatus, setInputUrl } = newLoginSlice.actions;
export const selectNewLogin = (state: RootState) => state.newLogin;
export default newLoginSlice.reducer;
